import moment from "moment";
import { PartnershipEntity } from "../entities/PartnershipEntity";
import { PartnershipFormData, PartnershipInfraOwner } from "@/@types/dtos/partnerships.types";
import { BasePartnership } from "./BasePartnership";
import { UserEntity } from "../entities/UserEntity";

export class Partnership extends BasePartnership {
  partner_cut: number;
  chargers_count: number;
  partner_code: string;
  is_partner_greezon: boolean
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  users: UserEntity[];

  constructor(partnership: PartnershipEntity) {
    super({
      id: partnership.id,
      name: partnership.name,
      logo_path: partnership.logo_path,
      infra_owner: partnership.infra_owner
    })
    const getChargersCount = () => {
      if (partnership.chargers_count) return partnership.chargers_count
      if (partnership.chargers) {
        return partnership.chargers.length
      }
      return 0
    }

    this.partner_cut = partnership.partner_cut
    this.chargers_count = getChargersCount()
    this.partner_code = partnership.partner_code
    this.is_partner_greezon = partnership.partner_code == "gz"
    this.created_at = partnership.created_at
    this.created_at = moment(partnership.created_at).format("DD/MM/YYYY")
    this.updated_at = partnership.updated_at
    this.deleted_at = partnership.deleted_at
    this.users = partnership.users || []
  }


  static empty: Partnership = {
    id: "",
    logo: "",
    name: "",
    partner_cut: 0,
    chargers_count: 0,
    partner_code: "",
    infra_owner: "",
    is_third_party_infra: false,
    is_partner_greezon: false,
    modality: 'A',
    created_at: "",
    updated_at: "",
    deleted_at: "",
    users: [],
  }
  static emptyForm: PartnershipFormData = {
    name: "",
    partner_cut: "",
    logo: {},
    infra_owner: PartnershipInfraOwner.partner,
    user_name: "",
    user_email: "",
    partner_code: "",
  }
}
